import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { Box, Button, InputAdornment } from "@mui/material";
import { useDispatch } from "react-redux";

const GenerateResponse = ({ text, setText }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [localText, setlocalText] = useState(text);
  useEffect(() => {
    setlocalText(text);
  }, [text]);
  const dispatch = useDispatch();

  const handleCopyClick = () => {
    navigator.clipboard.writeText(localText);
  };

  const handleChange = (event) => {
    setText(event.target.value);
    setlocalText(event.target.value);
  };

  return (
    <Box
    aria-label='Vanilla Response'
      sx={{ width: "100%" ,height:'100%'}}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <TextField
       
        fullWidth
        label="Vanilla Response"
        multiline
        size="small"
        // rows={1}
        variant="outlined"
        sx={{height:'calc(100% - 30px)',mt:2, "& .MuiInputBase-root": {
          height: "100%",
          display: "flex",
          alignItems: "start"
        }}}
        margin="normal"
        value={localText}
        onChange={(e) => handleChange(e)}
        InputProps={{
          endAdornment: isHovered && (
            <InputAdornment
              position="end"
              sx={{ position: "absolute", top: 20, right: 5 }}
            >
              {typeof text === "string" && text.trim() !== "" && (
                <IconButton size="small" onClick={handleCopyClick}>
                  <FileCopyIcon size="small" />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default GenerateResponse;
